import { postInternalMessage } from '../initialize';
import { LEARN_MORE_HOST_MSG } from '../methods/callingSharedWorkerMessageTypes';
export function createLearnMoreMessage() {
  return {
    type: LEARN_MORE_HOST_MSG
  };
}
export default function learnMoreMessageHandler() {
  postInternalMessage(createLearnMoreMessage());
}